import React from 'react';

import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  ExternalPAGES,
  getPageWithID,
} from 'src/common/components/tfa-auth/constants/pages';

const SmartLaunchAuthScreen: React.FC = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  React.useEffect(() => {
    if (token && id) {
      localStorage.setItem('smartLaunchJWT', token);
      navigate(getPageWithID(ExternalPAGES.smartLaunch, parseInt(id)));
    }
  }, [id, token, navigate]);

  return <></>;
};

export default SmartLaunchAuthScreen;
